import React, { useState } from 'react';
import loadable from '@loadable/component';
import { Link } from 'react-router-dom';
import { BASE_PATH, trackEvent, VIEW_PATHS } from '../../models/globals';
// Lazy load
const CloseIcon = loadable(() => import('@material-ui/icons/Close'));
const AccountCircle = loadable(() => import('@material-ui/icons/AccountCircle'));

function Header({ firstName, signOut, shouldHideGetCovered }) {
	const [mobileMenuOpen, setMenuOpen] = useState(false);
	const [mobileMenuClass, setMenuClass] = useState('');
	const toggleMobileMenu = (doTrack) => {
		if (doTrack) {
			trackEvent('toggle_menu', 'click');
		}
		if (!mobileMenuOpen) {
			setMenuOpen(true);
			setMenuClass('slide-in');
		} else {
			setMenuOpen(false);
			setMenuClass('slide-out');
		}
	};
	const handleClick = (status) => {
		trackEvent(`menu_${status}`, 'click');
		toggleMobileMenu(false);
	};
	return (
		<div>
			{/* slider menu */}
			<div
				className={`container-fluid navbar-dark w-100 w-sm-50 w-lg-25 ${mobileMenuClass}`}
				id="mobile-menu"
			>
				<div
					className="d-flex flex-row justify-content-between align-items-center mt-3 py-3"
					id="mobile-header"
					style={{ borderBottom: '2px solid #fff' }}
				>
					<div className="color-white">
						<h2 className="text-uppercase mb-0 color-white">
							<AccountCircle
								style={{ fontSize: '1.2em', verticalAlign: 'bottom' }}
							/>
							{' '}
							Hi
							{(firstName && `, ${firstName}`) || ''}
							!
						</h2>
					</div>
					<div>
						<CloseIcon
							onClick={toggleMobileMenu}
							style={{ cursor: 'pointer' }}
						/>
					</div>
				</div>
				<div className="d-flex flex-column">
					<ul className="navbar-nav" id="main-mobile-nav">
						<li className="nav-item">
							<Link
								to={BASE_PATH}
								onClick={() => handleClick('home')}
								className="customers-nav-link closer btn-no-btn text-uppercase mt-3"
							>
								Dashboard
							</Link>
						</li>
						{shouldHideGetCovered ? null : (
							<li className="nav-item">
								<Link
									to={`${BASE_PATH}/${VIEW_PATHS.PURCHASE}`}
									onClick={() => handleClick('customize-policy')}
									className="customers-nav-link closer btn-no-btn text-uppercase mt-3"
								>
									Get Covered
								</Link>
							</li>
						)}
						<li className="nav-item">
							<Link
								to={`${BASE_PATH}/${VIEW_PATHS.POLICIES}`}
								onClick={() => handleClick('policies')}
								className="customers-nav-link closer btn-no-btn text-uppercase mt-3"
							>
								My Policies
							</Link>
						</li>
						<li className="nav-item">
							<Link
								to={`${BASE_PATH}/${VIEW_PATHS.CLAIMS}`}
								onClick={() => handleClick('claims')}
								className="customers-nav-link closer btn-no-btn text-uppercase mt-3"
							>
								Claims
							</Link>
						</li>
						<li className="nav-item">
							<Link
								to={`${BASE_PATH}/${VIEW_PATHS.SETTINGS}`}
								className="customers-nav-link closer btn-no-btn text-uppercase mt-3"
								onClick={() => handleClick('settings')}
							>
								Account
							</Link>
						</li>
						<li className="nav-item">
							<Link
								to={`${BASE_PATH}/${VIEW_PATHS.HELP}`}
								onClick={() => handleClick('help')}
								className="customers-nav-link closer btn-no-btn text-uppercase mt-3"
							>
								Help
							</Link>
						</li>
					</ul>
					<hr />
					<div className="d-flex justify-content-center">
						<button
							type="button"
							className="btn btn-blue"
							onClick={signOut}
						>
							Sign Out
						</button>
					</div>
				</div>
			</div>
			{/* End of slider menu */}
			{/* Nav bar */}
			<nav
				className="navbar navbar-dark bg-navy shadow w-100"
				style={{ position: 'fixed', zIndex: 1000 }}
			>
				<div className="d-flex justify-content-between align-items-center w-100">
					<div className="w-100">
						<button
							id="toggler"
							className="navbar-toggler custom-toggler"
							type="button"
							aria-controls="navbarCollapse"
							aria-expanded="false"
							aria-label="Toggle navigation"
							onClick={toggleMobileMenu}
							data-testid="menu-button"
						>
							<span className="navbar-toggler-icon" />
						</button>
					</div>
				</div>
			</nav>
		</div>
	);
}

export default Header;
